// @ts-nocheck

import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';
import React, { PureComponent } from 'react';

import Dropdown from '../../../../../common/components/core/Dropdown';

const iconClassName = css({
  fontFamily: 'Material Icons',
  fontSize: theme.typography.h3.fontSize,
  color: theme.colors.gray[400],
  paddingRight: '5px',
});

const defaultCustomStyles = {
  control: (providedStyling) => ({
    ...providedStyling,
    boxSizing: 'border-box',
    height: '35px',
    border: `1px solid ${theme.colors.gray.neutral}`,
    borderRadius: '8px',
    backgroundColor: theme.colors.primary.contrastWhite,
  }),
};

export class CustomDropdownIndicator extends PureComponent {
  render() {
    if (!this.props.icon) {
      return null;
    }
    return <span className={iconClassName}>{this.props.icon}</span>;
  }
}

class DiscoAdsCreatorCustomDropdown extends PureComponent {
  render() {
    const { customStyles, onMenuOpen, onMenuClose, icon, ...remainingProps } = this.props;
    const styles = { ...defaultCustomStyles, ...customStyles };
    return (
      <Dropdown
        onOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        styles={styles}
        components={{
          DropdownIndicator: () => <CustomDropdownIndicator icon={icon} />,
        }}
        {...remainingProps}
      />
    );
  }
}

export default DiscoAdsCreatorCustomDropdown;
